import { render, staticRenderFns } from "./FacturaCliente.vue?vue&type=template&id=cfc360a4"
import script from "./FacturaCliente.vue?vue&type=script&lang=js"
export * from "./FacturaCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports